module.exports = __webpack_public_path__ + "media/expect-good-news.1bfd09de.mp3";